import { render, staticRenderFns } from "./TerminalDetailsContainer.vue?vue&type=template&id=0080fb4e"
import script from "./TerminalDetailsContainer.vue?vue&type=script&lang=js"
export * from "./TerminalDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports